// extracted by mini-css-extract-plugin
export default {"bindWallet":"BindWallet_bindWallet__GdP7p"};